<template>
  <div class="login-view">
    <div class="card bg-light">
      <div class="logo w-50">
        <img src="../assets/logo.png" alt="logo" width="256" />
      </div>
      <div class="container-formulario">
        <div class="formulario">
          <fieldset :disabled="carregando">
            <h5 class="font-weight-bold">Thorpe Coletor</h5>
            <br>
            <div v-show="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>
            <div class="form-group mt-3">
              <input
                @keydown.enter="(e) => enterKey(e)"
                v-model="data.login"
                type="text"
                id="login"
                name="login"
                :class="
                  'form-control text-center ' +
                  (errors.login ? 'is-invalid' : '')
                "
                placeholder="Login"
              />
              <div v-if="errors.login" class="invalid-feedback d-block">
                {{ errors.login[0] }}
              </div>
            </div>
            <div class="form-group">
              <input
                @keydown.enter="(e) => enterKey(e)"
                v-model="data.senha"
                type="password"
                id="password"
                name="password"
                :class="
                  'form-control text-center ' +
                  (errors.senha ? 'is-invalid' : '')
                "
                placeholder="Senha"
              />
              <div v-if="errors.senha" class="invalid-feedback d-block">
                {{ errors.senha[0] }}
              </div>
            </div>
            <div class="form-group">
              <select
                onchange="if(this.value.trim() !== '') {this.setAttribute('style', '')}"
                @keydown.enter="(e) => enterKey(e)"
                v-model="data.base"
                type="base"
                id="base"
                name="base"
                :class="
                  'form-control text-center ' +
                  (errors.base ? 'is-invalid' : '')
                "
                placeholder="Base"
              >
                <option value="" disabled>Base</option>
                <option v-for="(b, k) in BASES" :key="'base-' + k" :value="k">{{ b.label }}</option>
              </select>
              <div v-if="errors.base" class="invalid-feedback d-block">
                {{ errors.base[0] }}
              </div>
            </div>
            <button
              class="btn btn-primary btn-block"
              @click="handleLogin"
              id="btnLogin"
            >
              Entrar
              <div v-show="carregando" class="spinner-grow">
                <span class="sr-only">Loading...</span>
              </div>
            </button>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { enterKey, focar } from "../utils";
import {
  DEFAULT_ERROR_MESSAGE,  
  ServerErrorException,
  ValidationException,
} from "../services/exceptions";
import api, { getRotaDeRetorno, setAdminToken, setInventarioToken, setUserId, setUsername, setPerfil, BASES, setBase, getBase } from "../services/api";

export default {
  name: "Login",
  data: function () {
    return {
      BASES,
      carregando: false,
      data: {
        login: "",
        senha: "",
        base: "",
      },
      errors: {},
      errorMessage: "",
    };
  },

  mounted() {
    focar('#login')
    this.data.base = getBase() || "";
  },

  methods: {
    enterKey,

    async handleLogin() {

      if (document.getElementById('base').value.trim() === "") {
        document.getElementById('base').setAttribute('style', 'border: 1px solid red;');
        this.errorMessage =  "Informe a base!";
        return;
      }

      this.carregando = true;

      try {
        let data = await this.apiLogin();
        setAdminToken(data.token);
        setUsername(data.nome);
        setUserId(data.id);
        setPerfil(data.idPerfil);
        setBase(this.data.base);

        let b64Content = data.login + ":" + this.data.senha;
        let inventarioToken = btoa(b64Content);
        setInventarioToken(inventarioToken);

        let pushRoute = getRotaDeRetorno();
        if (!pushRoute || pushRoute == '/login') {
          pushRoute = "/home";
        }
        this.$router.push(pushRoute);
      } catch (e) {
        if (e instanceof ValidationException) {
          this.handleValidationException(e);          
          this.data.senha = "";
          focar('#password');
        } else if (e instanceof ServerErrorException) {
          this.errorMessage = e.message;
        } else {
          this.errorMessage = DEFAULT_ERROR_MESSAGE;
        }
      } finally {
        this.carregando = false;
      }
    },

    async apiLogin() {
      let response = await api.post("login", this.data);
      let data = response.data;
      return data;
    },

    handleValidationException(e) {
      this.errors = e.errors;
      this.errorMessage = e.errorMessage;

      let campos = Object.keys(e.errors);
      if (campos.length > 1) {
        focar("#" + campos[0]);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login-view {
  background-color: hsl(230, 50%, 25%);
  height: 100%;
  padding-top: 7.5vh;
}

.login-view .card {
  flex-direction: row !important;

  margin: 0 7.5vw;
}

.logo {
  display: none;
}

img {
  filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.1));
}

.container-formulario {
  width: 100%;
}

.formulario {
  margin: 3em;
}

h3 {
  margin-bottom: 1em !important;
}

input,
select,
button {
  font-size: 1.2em !important;
  border-radius: 25px !important;
}

.spinner-grow {
  width: 1em;
  height: 1em;
}

@media only screen and (min-width: 768px) {
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;

    border-right: 1px solid rgba(0, 0, 0, 0.125);
  }

  .container-formulario {
    width: 50%;
  }

  .login-view .card {
    flex-direction: row !important;

    margin: 0 24vw;
  }
}
</style>
